import { useMutation } from '../../../../ReactQuery';
import { post } from '../../../../redux/api';

/**
 * Resend email verification code during login
 * Note: Does not show toast - errors should be handled by the component
 */
export function useResendEmailLoginCode() {
  return useMutation({
    mutationFn: async () => {
      return post<never, void>('/api/auth/mfa/email/resend-login', undefined as never);
    },
  });
}
